
export default class podcastPlayer {
    constructor() {

        this.intervalProgress;
        this.audioPlayer;
        this.isPlaying = false;
        this.containers = document.querySelectorAll('.cp-podcast');
        if (this.containers.length === 0) return;

        this.btnsPlayAudio = [];
        this.btnsControlAudio = [];
        this.iAudio = 0;




        Array.from(this.containers).forEach((container) => {
            if (container.querySelector('.cp-podcast__player')) {
                this.btnsPlayAudio.push(container.querySelectorAll('.play-c'));
                this.audioPlayer = container.querySelector('.cp-podcast__player');
                this.btnsControlAudio.push(container.querySelectorAll('.audio-btn-control'));
               // this.initPlayer( this.audioPlayer);

            }
        });

        Array.from(this.btnsPlayAudio[0]).forEach((btnPlayAudio) => {
            btnPlayAudio.addEventListener('click', this.clickPlay.bind(this));
        });

        Array.from(this.btnsControlAudio[0]).forEach((btnControlAudio) => {
            btnControlAudio.addEventListener('click', this.controlAudio.bind(this));
        });


        // SHARE
        this.btnOpenShare = document.querySelector('.js-btn-open-share');
        this.btnOpenShare.addEventListener('click', this.toggleShare.bind(this));
        document.querySelector('.equalizer-c').addEventListener('click', this.clickProgress.bind(this))

    }

    clickPlay(a){
        if(this.iAudio == 0) {
            this.iAudio = 1;
            this.initPlayer(a);
        }else{
            this.toggleAudio(a)
        }
    }

    initPlayer(a){
        document.querySelector('.controls').classList.add("active");
        let audioE = document.createElement("AUDIO");
        document.querySelector('.audio-c').appendChild(audioE);
        const mp3file = document.querySelector('.cp-podcast__player').dataset.mp3;
        audioE.setAttribute("src",mp3file);
        this.toggleAudio(a);
    };

    progressSize(audio){
        this.intervalProgress = setInterval(() => {
            const progressBar =  this.audioPlayer.querySelector(".equalizer-c-progress");
            progressBar.style.width = audio.currentTime / audio.duration * 100 + "%";
            let cTime = this.getTimeCodeFromNum(audio.currentTime);
            let mp3Current =  this.audioPlayer.querySelectorAll(".mp3-current-time");
            [].forEach.call(mp3Current, function(el) {
                el.textContent = cTime;
            });
        }, 500);
    }

    toggleAudio(event){

        let audio = event.currentTarget.closest('.cp-podcast__player').querySelector('audio');
        let btns =  event.currentTarget.closest('.cp-podcast__player').querySelectorAll(".toggle-play");
        if (audio.paused) {
            audio.play();
            [].forEach.call(btns, function(el) {
                el.classList.remove("play");
                el.classList.add("pause");
            });
            this.progressSize(audio);
        } else {
            audio.pause();
            [].forEach.call(btns, function(el) {
                el.classList.remove("pause");
                el.classList.add("play");
            });
            clearInterval(this.intervalProgress);
        }
    }

    controlAudio(event){
        let btns =  event.currentTarget.closest('.cp-podcast__player').querySelectorAll(".toggle-play");
        let audio = event.currentTarget.closest('.cp-podcast__player').querySelector('audio');
        let direction = event.currentTarget.dataset.control;
        let newTime;
        if(direction == 'prev'){
             newTime = audio.currentTime - 10;
        }else{
             newTime = audio.currentTime + 10;
        }
        if(audio.paused){
            audio.play();
            this.progressSize(audio);
            [].forEach.call(btns, function(el) {
                el.classList.remove("play");
                el.classList.add("pause");
            });
        }
        audio.currentTime = newTime;
    }

    getTimeCodeFromNum(num) {
        let seconds = parseInt(num);
        let minutes = parseInt(seconds / 60);
        seconds -= minutes * 60;
        const hours = parseInt(minutes / 60);
        minutes -= hours * 60;

        if (hours === 0) return `${minutes}:${String(seconds % 60).padStart(2, 0)}`;
        return `${String(hours).padStart(2, 0)}:${minutes}:${String(
            seconds % 60
        ).padStart(2, 0)}`;
    }

    toggleShare(event){
        let container = event.currentTarget.closest('.share-c').querySelector('.social');
        container.classList.toggle('open')
    }

    clickProgress(event){
        let audio = event.currentTarget.closest('.cp-podcast__player').querySelector('audio');
        if(audio.currentTime == 0){
            this.toggleAudio(event);
        }else{
            let xP = event.offsetX;
            let eW = event.currentTarget.offsetWidth;
            let purcentX = (100*xP)/eW;
            let newTime = (purcentX*audio.duration)/100;
            audio.currentTime = newTime;
        }

    }



}
